import { pxToRem, theme } from '@pocketlaw/tetris';
export const TREE_NODE_ICON_SIZE = pxToRem(32);
export const TREE_NODE_MARGIN = pxToRem(4);
export const TREE_NODE_MARGIN_HALF = pxToRem(2);
export const TREE_BRANCH_COLOR = theme.swatches.gray[100];
